<template>
  <v-dialog v-model="dialog" width="550" scrollable>
    <v-card v-if="dialog">
      <v-card-title>
        <span v-if="loading">Aguarde...</span>
        <div v-else>
          Notas e boletos
          <br />
          <span class="subtitle-1"
            >Cliente: {{ ordem.cliente.id }} - {{ ordem.cliente.nome }}</span
          >
        </div>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <template v-if="loading">
          <v-skeleton-loader type="list-item-three-line" />
          <v-skeleton-loader type="list-item-three-line" />
        </template>
        <v-list v-else three-line>
          <v-subheader v-if="fatura"
            >Boletos da fatura {{ fatura.numero }}</v-subheader
          >
          <v-list-item-group
            v-if="fatura"
            v-model="boletosSelecionadosFatura"
            multiple
          >
            <v-list-item
              v-for="(cr, i) in fatura.contasreceber"
              :key="`cr-${i}`"
              :value="cr"
              :disabled="cr.id_forma_pagamento !== 1"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    @click="toggle"
                    :disabled="cr.id_forma_pagamento !== 1"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ cr.forma_pagamento.descricao }} -
                    {{ cr.documento }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ cr.conta_bancaria.descricao }} ({{
                      cr.conta_bancaria.banco.nome
                    }}) - AG {{ cr.conta_bancaria.agencia }} CC
                    {{ cr.conta_bancaria.conta }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="font-weight-bold">
                    Vencimento {{ vencimento(cr) }} R$
                    {{ valor(cr) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
          <v-subheader v-if="nf">Boletos da NFS-e {{ nf.numero }}</v-subheader>
          <v-list-item-group v-if="nf" v-model="boletosSelecionadosNF" multiple>
            <v-list-item
              v-for="(cr, i) in nf.contasreceber"
              :key="`cr-${i}`"
              :value="cr"
              :disabled="cr.id_forma_pagamento !== 1"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    @click="toggle"
                    :disabled="cr.id_forma_pagamento !== 1"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ cr.forma_pagamento.descricao }} -
                    {{ cr.documento }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ cr.conta_bancaria.descricao }} ({{
                      cr.conta_bancaria.banco.nome
                    }}) - AG {{ cr.conta_bancaria.agencia }} CC
                    {{ cr.conta_bancaria.conta }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="font-weight-bold">
                    Vencimento {{ vencimento(cr) }} R$
                    {{ valor(cr) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-text class="px-4" v-if="fatura || nf">
        <v-checkbox
          v-if="fatura"
          v-model="incluirFatura"
          label="Incluir documento de fatura"
        />
        <v-checkbox
          v-if="nf"
          v-model="incluirDANFE"
          label="Incluir DANFE da NFS-e"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn
          color="primary"
          depressed
          @click="visualizar()"
          :disabled="disabled"
        >
          <v-icon class="mr-2">mdi-eye-outline</v-icon>VISUALIZAR
        </v-btn>
        <seletor-email
          tipo-entidade="clientes"
          :id-entidade="ordem.id_cliente"
          tipo-padrao="financeiro"
          @confirmar="enviarEmail(ordem, $event)"
        >
          <v-btn
            color="secondary"
            depressed
            :disabled="disabled || enviandoEmail"
            class="ml-2"
          >
            <v-icon class="mr-2">mdi-email-send-outline</v-icon>
            {{ enviandoEmail ? "ENVIANDO" : "ENVIAR EMAIL" }}
          </v-btn>
        </seletor-email>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import number_format from "../../lib/number_format";
import SeletorEmail from "../contatos/SeletorEmail";
export default {
  components: { SeletorEmail },
  data() {
    return {
      loading: true,
      enviandoEmail: false,
      fatura: null,
      nf: null,
      incluirFatura: true,
      incluirDANFE: true,
      boletosSelecionadosFatura: [],
      boletosSelecionadosNF: [],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.boleto.seletor.ordemAtiva !== null;
      },
      set(val) {
        if (!val) {
          this.$store.commit("boleto/setOrdemAtivaSeletor", null);
        }
      },
    },
    disabled() {
      return (
        this.loading ||
        (this.boletosSelecionadosFatura.length === 0 &&
          !this.incluirFatura &&
          this.boletosSelecionadosNF.length === 0)
      );
    },
    ...mapState({
      ordem: (state) => state.boleto.seletor.ordemAtiva,
    }),
  },
  methods: {
    async carregarCR() {
      this.loading = true;
      try {
        const responseFatura = await this.$store.dispatch(
          "ordemMedicao/buscarFaturaPorOrdem",
          {
            CarregarContasReceber: true,
            filtros: { id_ordem: this.ordem.id },
          }
        );
        this.fatura = responseFatura.data[0];

        const responseNota = await this.$store.dispatch(
          "ordemMedicao/buscarNotaPorOrdem",
          {
            CarregarContasReceber: true,
            filtros: { id_ordem: this.ordem.id },
          }
        );
        this.nf = responseNota.data[0];
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a fatura/nf",
        });
      }
      this.loading = false;
    },
    vencimento(cr) {
      return moment(cr.data_vencimento).format("DD/MM/YYYY");
    },
    valor(cr) {
      return number_format(cr.valor_receber);
    },
    async gerarImpressoes() {
      const p = [];
      if (this.fatura && this.incluirFatura) {
        p.push(
          this.$store.dispatch("relatorio/gerarFatura", this.fatura.id_ordem)
        );
      }
      if (this.nf && this.incluirDANFE) {
        p.push(this.$store.dispatch("ordemMedicao/arquivoNota", this.nf.id));
      }

      for (let cr of this.boletosSelecionadosFatura) {
        p.push(this.$store.dispatch("boleto/arquivoBoleto", cr.id));
      }
      for (let cr of this.boletosSelecionadosNF) {
        p.push(this.$store.dispatch("boleto/arquivoBoleto", cr.id));
      }
      try {
        const impressoes = await Promise.all(p);
        return Promise.resolve(impressoes);
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível recuperar os boletos",
        });
        return Promise.reject(err);
      }
    },
    visualizar() {
      this.gerarImpressoes().then((impressoes) => {
        for (let impressao of impressoes.reverse()) {
          const url = window.URL.createObjectURL(
            new Blob([impressao], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 3000);
          link.remove();
        }
      });
    },
    async enviarEmail(om, emails) {
      this.enviandoEmail = true;
      try {
        const impressoes = await this.gerarImpressoes();
        const payload = new FormData();
        
        payload.append("id_ordem", om.id);

        payload.append("nomeCliente", om.cliente.nome);
        if (this.fatura) {
          payload.append("numeroFatura", this.fatura.numero);
        }
        if (this.nf) {
          payload.append("numeroNFS", this.nf.numero);
        }
        if (this.fatura && this.incluirFatura) {
          const arquivo = new File([impressoes.shift()], `FATURA_${this.fatura.numero}.pdf`, {
            type: "application/pdf",
          });
          payload.append("arquivos", arquivo);
        }

        if (this.nf && this.incluirDANFE) {
          const arquivo = new File([impressoes.shift()], `NF_${this.nf.numero}.pdf`, {
            type: "application/pdf",
          });
          payload.append("arquivos", arquivo);
        }

        const boletos = this.boletosSelecionadosFatura.concat(
          this.boletosSelecionadosNF
        );

        for (let i = 0; i < impressoes.length; i++) {
          let documento = boletos[i].documento;
          const parts = documento.split("/");
          documento = `${parts[0]}-${parts[1]}`;

          const arquivo = new File([impressoes[i]], `BOL_${documento}.pdf`, {
            type: "application/pdf",
          });
          payload.append("arquivos", arquivo);
        }

        payload.append("emails", emails.join(","));

        await this.$store.dispatch("email/boletos", {
          payload,
        });
        this.dialog = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Email enviado com sucesso",
          color: "success",
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível enviar o email ao cliente",
        });
      }
      this.enviandoEmail = false;
    },
  },
  watch: {
    dialog(val) {
      this.boletosSelecionadosFatura = [];
      this.boletosSelecionadosNF = [];
      if (!val) {
        return;
      }

      this.carregarCR();
    },
  },
};
</script>
